module.exports = __webpack_public_path__ + "static/img/oil.fa11345.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/oil.jpg
// module id = lWG/
// module chunks = 1